module.exports = __webpack_public_path__ + "img/emoji-sex-online-240x240.7310877a.png";